"use client";
import { use, createContext } from "react";
import { type IDevice } from "ua-parser-js";

export type DeviceProps = Pick<IDevice, "type" | "model" | "vendor">;

export const DeviceContext = createContext<DeviceProps | null>(null);

export const useDevice = () => {
	const device = use(DeviceContext);

	if (!device)
		throw new Error("useDevice must be used within a DeviceProvider");

	return device;
};
